import { createSelector } from '@ngrx/store';
import { DeleteAnnouncementDialogState } from './delete-announcement-dialog.state';
import { selectDialogs } from '../../+store';

/**
 * Selectors für den Delete-Announcement-Dialog.
 */
export class DeleteAnnouncementDialogSelectors {
  private static readonly _slice = createSelector(
    selectDialogs,
    (state): DeleteAnnouncementDialogState => state.deleteAnnouncementDialog,
  );

  /**
   * Selector für den isOpen-Status.
   */
  public static readonly isOpen = createSelector(
    this._slice,
    (state) => state.isOpen,
  );

  /**
   * Selector für das zu löschende Item.
   */
  public static readonly itemToDelete = createSelector(
    this._slice,
    (state) => state.itemToDelete,
  );
}
